import { Audited, ID } from '@ianesthesie-kit/services';

export interface AssignedQuestionnaireDto extends Audited {
  status: AssignedQuestionnaireStatus;
  type: QuestionnaireType;
  patientId: ID;
  surgicalEventId: ID;
  questionnaireCode: string;
  completedAt?: string;
}

export interface QuestionnaireInconsistency extends Audited {
  questionnaireType: string;
  inconsistency: string;
  penalty: number;
  translationCode: string;
}

/**
 * Inconsistencies raised when the patient's age or sex changed after the questionnaire was
 * completed. They carry no penalty and are shown apart from the accuracy ones.
 */
export const STALE_QUESTIONNAIRE_INCONSISTENCIES: readonly string[] = [
  'QUESTIONNAIRE_COMPLETED_BEFORE_AGE_CHANGE',
  'QUESTIONNAIRE_COMPLETED_BEFORE_SEX_CHANGE'
];

export type QuestionnaireInconsistenciesResponse = {
  questionnaireType: string;
  totalPenalty: number;
  inconsistencies: QuestionnaireInconsistency[];
};

export type FetchAssignedQuestionnairesParams = {
  questionnaireType?: QuestionnaireType;
  status?: AssignedQuestionnaireStatus | AssignedQuestionnaireStatus[];
};

export enum QuestionnaireType {
  PREOP = 'PREOP',
  EARLY_POSTOP = 'EARLY_POSTOP'
}

export enum AssignedQuestionnaireStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED'
}

export const isPendingStatus = (
  st?: AssignedQuestionnaireStatus
): st is
  | AssignedQuestionnaireStatus.IN_PROGRESS
  | AssignedQuestionnaireStatus.NOT_STARTED =>
  st === AssignedQuestionnaireStatus.IN_PROGRESS ||
  st === AssignedQuestionnaireStatus.NOT_STARTED;
